var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "virtual-transfer-demo" },
    [
      _vm._m(0),
      _c(
        "el-card",
        { staticClass: "demo-controls" },
        [
          _c("h3", [_vm._v("测试控制")]),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.generateTestData(1000)
                        },
                      },
                    },
                    [_vm._v("生成1000条数据")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.generateTestData(5000)
                        },
                      },
                    },
                    [_vm._v("生成5000条数据")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.generateTestData(10000)
                        },
                      },
                    },
                    [_vm._v("生成10000条数据")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "15px" } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-button", { on: { click: _vm.selectRandom } }, [
                    _vm._v("随机选择500项"),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-button", { on: { click: _vm.clearSelection } }, [
                    _vm._v("清空选择"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "demo-stats" },
        [
          _c("h3", [_vm._v("性能统计")]),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-item" }, [
                  _c("span", { staticClass: "stat-label" }, [
                    _vm._v("总数据量:"),
                  ]),
                  _c("span", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.totalCount)),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-item" }, [
                  _c("span", { staticClass: "stat-label" }, [
                    _vm._v("已选择:"),
                  ]),
                  _c("span", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.selectedCount)),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-item" }, [
                  _c("span", { staticClass: "stat-label" }, [
                    _vm._v("渲染时间:"),
                  ]),
                  _c("span", { staticClass: "stat-value" }, [
                    _vm._v(_vm._s(_vm.renderTime) + "ms"),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-item" }, [
                  _c("span", { staticClass: "stat-label" }, [
                    _vm._v("DOM节点:"),
                  ]),
                  _c("span", { staticClass: "stat-value" }, [_vm._v("~26个")]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "demo-content" },
        [
          _c("h3", [_vm._v("虚拟滚动Transfer组件")]),
          _c("virtual-transfer", {
            attrs: {
              data: _vm.testData,
              props: _vm.transferProps,
              titles: [
                "可选渠道(" + _vm.unselectedCount + ")",
                "已选渠道(" + _vm.selectedCount + ")",
              ],
              "button-texts": ["移除", "选择"],
              filterable: "",
            },
            on: { change: _vm.handleTransferChange },
            model: {
              value: _vm.selectedItems,
              callback: function ($$v) {
                _vm.selectedItems = $$v
              },
              expression: "selectedItems",
            },
          }),
        ],
        1
      ),
      _vm.performanceLogs.length > 0
        ? _c(
            "el-card",
            { staticClass: "demo-logs" },
            [
              _c("h3", [_vm._v("性能日志")]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.performanceLogs },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "timestamp", label: "时间", width: "180" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "action", label: "操作", width: "120" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "dataCount", label: "数据量", width: "100" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "renderTime",
                      label: "渲染时间(ms)",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "selectedCount",
                      label: "选中数量",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "memoryUsage",
                      label: "内存使用",
                      width: "120",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "demo-header" }, [
      _c("h2", [_vm._v("虚拟滚动Transfer组件演示")]),
      _c("p", [_vm._v("展示5000+数据量的性能优化效果")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }